import cookie from 'cookie-cutter';
import isUndefined from 'lodash/isUndefined';

export const ADD_ON = 'add_on';
export const BASICALLY_FOREVER_AGO = new Date('Dec 31, 1999');
export const DOMAIN = (globalThis.window?.location.hostname || '').split('.').slice(-2).join('.');

export function getCookie({
  name,
  defaultValue = null,
  isJSON = true,
}: {
  name: string;
  defaultValue?: unknown | null;
  isJSON?: boolean;
}) {
  try {
    let value = cookie.get(name);
    if (isJSON) {
      value = JSON.parse(value);
    }
    if (isUndefined(value)) {
      return defaultValue;
    }
    return value;
  } catch (error) {
    return defaultValue;
  }
}

export function setCookie({
  name,
  value,
  expires,
  path = '/',
  asJSON = true,
  domain,
}: {
  asJSON?: boolean;
  domain: string;
  expires: Date;
  name: string;
  path?: string;
  value?: unknown;
}) {
  let encodedValue = value;
  if (asJSON) {
    encodedValue = JSON.stringify(value);
  }
  cookie.set(name, encodedValue, {
    path,
    expires: expires.toUTCString(),
    domain,
  });
}

export function deleteCookie({ name, domain }: { name: string; domain: string }) {
  setCookie({ name, expires: BASICALLY_FOREVER_AGO, domain });
}
